module.exports = __webpack_public_path__ + "img/dp-hlbg.379b0d39.png";